<script setup lang="ts">
import type { ShipexkursIconName } from '~/utils/shipexkurs-icons';

defineProps<{ title: string; icon?: ShipexkursIconName }>();
</script>

<template>
  <div class="flex flex-col rounded-lg bg-bunker-950 ring-1 ring-white/10">
    <div class="flex items-center justify-between gap-2 border-b border-white/10 px-4 py-2.5">
      <div class="flex items-center gap-2">
        <!-- <span class="size-1.5 shrink-0 rounded-full bg-industrial-400" /> -->
        <UChip standalone inset class="animate-pulse shadow-[0_0px_20px_#00ffe8]" />
        <ShipexkursSystemIcon v-if="icon" :name="icon" class="size-4 shrink-0 text-aris-400" />
        <h3 class="!my-0 text-xs font-semibold uppercase tracking-wide text-white">{{ title }}</h3>
      </div>
      <slot name="header-trailing" />
    </div>
    <div class="flex-1 p-4">
      <slot />
    </div>
  </div>
</template>
